import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { ParametroDTO } from 'src/app/core/models/residencia/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlResidencia;

@Injectable()
export class ParametroService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getParametroService(): Observable<BodyListResponse<ParametroDTO>> {
    return this.http.get<BodyListResponse<ParametroDTO>>(API_URL + '/api/v1/parametro/todos');
  }

  guardarParametroService(parametroDTO: ParametroDTO): Observable<any> {
    return this.http.post<ParametroDTO>(API_URL + '/api/v1/parametro', parametroDTO);
  }

  getParametroPorCodigoParametroService(codigoParametro: string): Observable<BodyResponse<ParametroDTO>> {
    return this.http.get<BodyResponse<ParametroDTO>>(API_URL + '/api/v1/parametro/' + codigoParametro);
  }
}
